import { notapUrls } from "./notapUrls"
import { onboardUrls } from "./onBoardUrls"
import { bankUrls } from "./bankUrls"
import { transfereeUrls } from "./transfereeUrls"
import { guestUrls } from "./guestUrls"
import { adminUrls } from "./adminUrls"

export const appUrls = {
    // 'transactionHistory': '/certificates/:certificateNo/transaction-history',
    ...adminUrls,
    ...notapUrls,
    ...onboardUrls,
    ...bankUrls,
    ...transfereeUrls,
    ...guestUrls,
};